import styled from "styled-components";

const DivMargin = styled.div`
  margin-top: 30px;
`;


export default DivMargin;
